import React from "react";

import { StyledSpinner } from "../styles/StyledSpinner";

const Spinner = () => {
  return <StyledSpinner />;
};

export default Spinner;
